import { FunctionComponent } from 'react';
 
const FilterMarginInfoCard: FunctionComponent = () => {
    return <><h3 className="text-primary-std font-medium">Value set by a filter</h3>
    <p className="text-secondary-std text-sm leading-tight">
    This value has been set as this product matches a filter you have defined. 
    You can override the value for this product or edit the filter affecting all of them.
    </p></>;
}
 
export default FilterMarginInfoCard;